import { useEffect } from "react"

const useTitle = title =>{
    useEffect(() =>{
       document.title = `${title} - Wild Snap`;
    }, [title])
};

export default useTitle; 